import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { MEAT_API, CHAVE_API } from '../app.api';
import { Equipamento, Usuario } from '../models/model';
import { Observable } from 'rxjs/Observable';
import { ErrorHandler } from '../app.error-handler';
import 'rxjs/add/operator/catch';



@Injectable()
export class EquipamentoService {

    private equipamento: Equipamento;

    constructor(private http: Http) { }

    registrarDispositivo(cnpj: string): Observable<String> {

        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('cnpj', cnpj);
        return this.http.post(`${MEAT_API}/api/dispositivo`,
            JSON.stringify({
                chave: CHAVE_API,
                descricao: "IntegraWEB",
                ativo: "S"
            }), new RequestOptions({ headers: headers }))
            .map((response) => {
                this.equipamento = response.json();
                return "ok";
            })
            .catch(ErrorHandler.handleError);
    }

    getEquipamento(): Equipamento {
        return this.equipamento;
    }
}


// WEBPACK FOOTER //
// ./src/app/services/equipamento.service.ts